import React from 'react';

import { DatePicker as DatePickerCore, IDatePickerProps as IDatePickerPropsCore } from '../core/date-picker';
import IcnDate from 'public/assets/icons/event.svg';
import { Icon } from 'components/icon/icon';

import styles from './datepicker.module.scss';

export interface IDatePickerProps extends IDatePickerPropsCore {
	showDateIcon?: boolean;
}

const getInitialDateFormat = (date: string | Date | null | undefined): 'dd-MM-yyyy' | 'dd-MM-yyyy - HH:mm' => {
	const dateToUse = new Date(date || '');
	if (dateToUse && dateToUse.getHours() === 0 && dateToUse.getMinutes() === 0) {
		return 'dd-MM-yyyy';
	}

	return 'dd-MM-yyyy - HH:mm';
};

const DatePicker = (props: IDatePickerProps): React.JSX.Element => {
	return (
		<div className={styles.datePicker}>
			<DatePickerCore
				{...props}
				propStyles={styles}
				initDateFormat={props.initDateFormat || getInitialDateFormat(props.value)}
			/>
			{props.showDateIcon && (
				<div className={styles.icon}>
					<Icon customIcon={<IcnDate />} size="14px" />
				</div>
			)}
		</div>
	);
};

export { DatePicker };
